import { DoqLayout, DoqType, DoqWithSpeechBubble } from '@ardoq/doq';
import { DashboardModes } from './types';
import { Stack } from '@ardoq/layout';
import styled from 'styled-components';
import { DASHBOARD_MIN_SCREEN_WIDTH_SMALL } from './consts';
import { type I18nLocale, t } from '@ardoq/i18n';

const EmptyMessageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// it doesn't track window resizing as it's a corner case that's unlikely to happen here, not worth extra complexity
const getDoqLayout = (): DoqLayout =>
  window.innerWidth > DASHBOARD_MIN_SCREEN_WIDTH_SMALL
    ? DoqLayout.PAGE
    : DoqLayout.VERTICAL;

const EmptyDashboard = ({
  dashboardMode,
  i18nLocale,
}: {
  dashboardMode: DashboardModes;
  i18nLocale: I18nLocale;
}) => {
  const title =
    dashboardMode === DashboardModes.VIEW
      ? t(
          i18nLocale,
          'dashboard:emptyDashboard.viewTitle',
          'There is no data to show'
        )
      : t(
          i18nLocale,
          'dashboard:emptyDashboard.metricsTitle',
          'No metrics to show'
        );
  const message =
    dashboardMode === DashboardModes.VIEW
      ? t(
          i18nLocale,
          'dashboard:emptyDashboard.viewMessage',
          'Build a dashboard and add charts to visualize your data.'
        )
      : t(
          i18nLocale,
          'dashboard:emptyDashboard.metricsMessage',
          'There are no usage metrics to display for the past month.\n\n This will be updated as Ardoq gets used more often within your organisation.'
        );

  return (
    <EmptyMessageContainer>
      <Stack justify="center" align="center">
        <DoqWithSpeechBubble
          doqType={DoqType.DASHBOARD_BELLY_MISSING_ORG}
          title={title}
          message={message}
          layout={getDoqLayout()}
        />
      </Stack>
    </EmptyMessageContainer>
  );
};

export { EmptyDashboard };
